import { render, staticRenderFns } from "./Sect.vue?vue&type=template&id=3951f85c&scoped=true&"
import script from "./Sect.vue?vue&type=script&lang=js&"
export * from "./Sect.vue?vue&type=script&lang=js&"
import style0 from "./Sect.vue?vue&type=style&index=0&id=3951f85c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3951f85c",
  null
  
)

export default component.exports